import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, LogIn } from "lucide-react";

import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { api, formatError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function MemberLogin() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ email: "", password: "" });

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/login", form);
      await refresh();
      nav("/painel");
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div
      className="max-w-md mx-auto px-5 md:px-8 py-16 md:py-24"
      data-testid="member-login-page"
    >
      <div className="text-center">
        <span className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-[#F0FDF4] text-[#166534]">
          <LogIn className="w-6 h-6" />
        </span>
        <h1 className="font-display mt-4 text-3xl font-extrabold tracking-tighter">
          Área do Associado
        </h1>
        <p className="mt-2 text-neutral-600 text-sm">Entre com seu e-mail e senha.</p>
      </div>

      <form
        onSubmit={onSubmit}
        className="mt-8 rounded-2xl border border-neutral-200 bg-white p-6 md:p-8 grid gap-4"
        data-testid="member-login-form"
      >
        <div>
          <Label htmlFor="email">E-mail</Label>
          <Input
            id="email"
            type="email"
            required
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="mt-1.5"
            data-testid="input-email"
          />
        </div>
        <div>
          <Label htmlFor="password">Senha</Label>
          <Input
            id="password"
            type="password"
            required
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            className="mt-1.5"
            data-testid="input-password"
          />
        </div>
        <Button
          type="submit"
          disabled={loading}
          data-testid="member-login-submit"
          className="rounded-full bg-[#166534] hover:bg-[#14532d] hover:text-white text-white h-11"
        >
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Entrar"}
        </Button>
      </form>

      <p className="mt-5 text-center text-sm text-neutral-600">
        Ainda não é associado?{" "}
        <Link to="/adesao" className="text-[#166534] font-semibold hover:underline">
          Fazer adesão
        </Link>
      </p>
    </div>
  );
}
